// extracted by mini-css-extract-plugin
var _1 = "eTYf0kyJDhgPQV6otxy7";
var _2 = "RQA6C3lC67o7zeBO_o5q";
export { _1 as "allCaps", _2 as "center" }
